import React, { FC } from 'react';
import { Carousel as ReactCarousel, CarouselProps as ReactCarouselProps } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Carousel.module.scss';

export type CarouselProps = {
  children: JSX.Element[];
  autoPlay?: boolean;
  interval?: number;
  transitionTime?: number;
  showArrows?: boolean;
  showThumbs?: boolean;
  showStatus?: boolean;
  showIndicators?: boolean;
  emulateTouch?: boolean;
  useKeyboardArrows?: boolean;
  animationHandler?: 'slide' | 'fade';
  infiniteLoop?: ReactCarouselProps['infiniteLoop'];
  selectedItem?: ReactCarouselProps['selectedItem'];
  renderArrowPrev?: ReactCarouselProps['renderArrowPrev'];
  renderArrowNext?: ReactCarouselProps['renderArrowNext'];
  renderIndicator?: ReactCarouselProps['renderIndicator'];
};

const CAROUSEL_PLAY_INTERVAL = 10_000;
const CAROUSEL_TRANSITION_TIME = 500;

export const Carousel: FC<CarouselProps> = ({
  autoPlay=true,
  children,
  interval=CAROUSEL_PLAY_INTERVAL,
  transitionTime=CAROUSEL_TRANSITION_TIME,
  showArrows=false,
  showThumbs=false,
  showStatus=false,
  showIndicators=true,
  emulateTouch=true,
  animationHandler='slide', // TODO: должно быть fade - https://jira.tennisi.it/browse/SITE-775
  infiniteLoop,
  renderArrowPrev,
  renderArrowNext,
  renderIndicator,
  ...props
}) => {
  return (
    <ReactCarousel {...props}
                   autoPlay={autoPlay}
                   infiniteLoop={infiniteLoop}
                   stopOnHover
                   emulateTouch={emulateTouch}
                   animationHandler={animationHandler}
                   interval={interval}
                   transitionTime={transitionTime}
                   showArrows={showArrows}
                   showThumbs={showThumbs}
                   showStatus={showStatus}
                   showIndicators={showIndicators}
                   renderArrowPrev={renderArrowPrev}
                   renderArrowNext={renderArrowNext}
                   renderIndicator={renderIndicator}>
      {children}
    </ReactCarousel>
  );
};
